export enum Relationships {
    AUNT = 'Aunt',
    BROTHER = 'Brother',
    CARETAKER = 'Caretaker',
    CASE_WORKER = 'Case Worker',
    COMPANION = 'Companion',
    COUSIN = 'Cousin',
    DAUGHTER = 'Daughter',
    DAUGHTER_IN_LAW = 'Daughter In Law',
    FATHER = 'Father',
    FATHER_IN_LAW = 'Father in Law',
    FRIEND = 'Friend',
    GRAND_DAUGHTER = 'Grand Daughter',
    GRAND_SON = 'Grand Son',
    HOME_PROVIDER = 'Home Provider',
    HOSPICE = 'Hospice',
    HUSBAND = 'Husband',
    MOTHER_IN_LAW = 'Mother In Law',
    MOTHER = 'Mother',
    NEPHEW = 'Nephew',
    NIECE = 'Niece',
    POWER_OF_ATTORNEY = 'Power of Attorney',
    PROGRAM_COORDINATOR = 'Program Coordinator',
    OTHER = 'Other',
    RESIDENTIAL_SUPPORT = 'Residential Support',
    SON_IN_LAW = 'Son In Law',
    SISTER = 'Sister',
    SON = 'Son',
    SOCIAL_WORKER = 'Social Worker',
    STEP_DAUGHTER = 'Step Daughter',
    STEP_SON = 'Step Son',
    WIFE = 'Wife',
    SPOUSE = 'Spouse'
}